export default "__VITE_ASSET__zC2y_fVO__"